module.exports = __webpack_public_path__ + "img/shelton-state-logo.19cfa0f8.jpg";